/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

export default {
  '.highcharts-background': {
    name: 'background',
    steps: [
      {
        element: '.node#chart',
        scrollToTop: true
      }
    ],
    after: 'rect.highcharts-background'
  },
  '.highcharts-plot-background': {
    name: 'plot-background',
    makeTransparent: true,
    steps: [
      {
        element: '.node#chart'
      },
      {
        parent: '.right-advance-panel',
        element: '#chart\\.\\plotBackgroundColor'
      }
    ],
    after: 'rect.highcharts-plot-background',
    highlights: [
      '#chart\\.\\plotBackgroundColor',
      '#chart\\.\\plotBackgroundImage',
      '#chart\\.\\plotBorderColor',
      '#chart\\.\\plotBorderWidth',
      '#chart\\.\\plotShadow'
    ]
  },
  '.highcharts-credits': {
    name: 'credits',
    canClickElement: true,
    steps: [
      {
        element: '.node#credits',
        scrollToTop: true
      }
    ],
    convertToRect: true,
    offset: true
  },
  '.highcharts-title': {
    name: 'title',
    canClickElement: true,
    steps: [
      {
        element: '.node#title',
        scrollToTop: true
      }
    ],
    convertToRect: true
  },
  '.highcharts-subtitle': {
    name: 'subtitle',
    canClickElement: true,
    steps: [
      {
        element: '.node#subtitle',
        scrollToTop: true
      }
    ],
    convertToRect: true
  },
  '.highcharts-legend': {
    name: 'legend',
    canClickElement: true,
    steps: [
      {
        element: '.node#legend',
        scrollToTop: true
      }
    ],
    mapSteps: [
      {
        element: '.node#colorAxis\\[0\\] > div',
        scrollToTop: true
      }
    ],
    convertToRect: true,
    useOriginal: true
  },
  '.highcharts-tooltip .highcharts-tooltip-box': {
    name: 'tooltip',
    steps: [
      {
        element: '.node#tooltip',
        scrollToTop: true
      }
    ],
    useOriginal: true
  },
  '.highcharts-exporting-group': {
    name: 'export-menu',
    steps: [
      {
        element: '.node#exporting',
        scrollToTop: true
      }
    ],
    convertToRect: true
  },
  '.highcharts-caption': {
    name: 'caption',
    canClickElement: true,
    steps: [
      {
        element: '.node#caption',
        scrollToTop: true
      }
    ],
    convertToRect: true
  },

  '.highcharts-label.highcharts-data-label': {
    steps: [
      {
        element: '.node#plotOptions'
      },
      {
        element: '.node#plotOptions\\.series'
      },
      {
        element: '.node#plotOptions\\.series\\.dataLabels > div',
        scrollToTop: true
      }
    ],
    highlightAll: true,
    useOriginal: true
  },
  '.highcharts-label.highcharts-series-label': {
    steps: [
      {
        element: '.node#plotOptions'
      },
      {
        element: '.node#plotOptions\\.series'
      },
      {
        element: '.node#plotOptions\\.series\\.label',
        scrollToTop: true
      }
    ],
    highlightAll: true,
    useOriginal: true
  },
  '.highcharts-axis.highcharts-yaxis .highcharts-axis-title': {
    name: 'yAxis-title',
    steps: [
      {
        element: '.node#yAxis\\[0\\] > div,.node#yAxis > div'
      },
      {
        element: '.node#yAxis\\[0\\]\\.title,.node#yAxis\\.\\title',
        scrollToTop: true
      }
    ],
    convertToRect: true,
    useCalculatedValue: true
  },
  '.highcharts-axis.highcharts-xaxis .highcharts-axis-title': {
    name: 'xAxis-title',
    steps: [
      {
        element: '.node#xAxis\\[0\\] > div,.node#xAxis > div'
      },
      {
        element: '.node#xAxis\\[0\\]\\.title,.node#xAxis\\.\\title',
        scrollToTop: true
      }
    ],
    convertToRect: true,
    useCalculatedValue: true
  },
  '.highcharts-series': {
    hideBorder: true,
    isSeries: true,
    name: 'series',
    steps: [
      {
        element: '.node#plotOptions'
      },
      {
        element: '.node#plotOptions\\.labels',
        scrollToTop: true
      }
    ]
  },
  '.everviz-dummy-rect.yaxis-container': {
    name: 'yAxis',
    steps: [
      {
        element: '.node#yAxis\\[0\\] > div,.node#yAxis > div',
        scrollToTop: true
      }
    ],
    before: '.everviz-dummy-rect.yaxis-label',
    disableOnStock: true
  },
  '.everviz-dummy-rect.yaxis-label': {
    name: 'yAxis-labels',
    highlightAll: true,
    steps: [
      {
        element: '.node#yAxis\\[0\\] > div,.node#yAxis > div'
      },
      {
        element: '.node#yAxis\\[0\\] .node#yAxis\\[0\\]\\.labels,.node#yAxis .node#yAxis\\.labels',
        scrollToTop: true
      }
    ]
  },
  '.everviz-dummy-rect.xaxis-container': {
    name: 'xAxis',
    steps: [
      {
        element: '.node#xAxis\\[0\\] > div,.node#xAxis > div',
        scrollToTop: true
      }
    ],
    before: '.everviz-dummy-rect.xaxis-label'
  },
  '.everviz-dummy-rect.xaxis-label': {
    name: 'xAxis-labels',
    highlightAll: true,
    steps: [
      {
        element: '.node#xAxis\\[0\\] > div,.node#xAxis > div'
      },
      {
        element: '.node#xAxis\\[0\\] .node#xAxis\\[0\\]\\.labels,.node#xAxis .node#xAxis\\.labels',
        scrollToTop: true
      }
    ]
  },
  '.everviz-dummy-rect.xaxis-gridline': {
    name: 'xAxis-gridlines',
    highlightAll: true,
    steps: [
      {
        element: '.node#xAxis\\[0\\] > div,.node#xAxis > div'
      },
      {
        parent: '.right-advance-panel',
        element: '#xAxis\\[0\\]\\.\\gridLineColor, #xAxis\\.\\gridLineColor'
      }
    ],
    highlights: [
      '#xAxis\\[0\\]\\.\\gridLineColor, #xAxis\\.\\gridLineColor',
      '#xAxis\\[0\\]\\.\\gridLineDashStyle, #xAxis\\.\\gridLineDashStyle',
      '#xAxis\\[0\\]\\.\\gridLineInterpolation, #xAxis\\.\\gridLineInterpolation',
      '#xAxis\\[0\\]\\.\\gridLineWidth, #xAxis\\.\\gridLineWidth',
      '#xAxis\\[0\\]\\.\\gridZIndex, #xAxis\\.\\gridZIndex'
    ]
  },
  '.everviz-dummy-rect.yaxis-gridline': {
    name: 'yAxis-gridlines',
    highlightAll: true,
    steps: [
      {
        element: '.node#yAxis\\[0\\] > div,.node#yAxis > div'
      },
      {
        parent: '.right-advance-panel',
        element: '#yAxis\\[0\\]\\.\\gridLineColor, #yAxis\\.\\gridLineColor'
      }
    ],
    highlights: [
      '#yAxis\\[0\\]\\.\\gridLineColor, #yAxis\\.\\gridLineColor',
      '#yAxis\\[0\\]\\.\\gridLineDashStyle, #yAxis\\.\\gridLineDashStyle',
      '#yAxis\\[0\\]\\.\\gridLineInterpolation, #yAxis\\.\\gridLineInterpolation',
      '#yAxis\\[0\\]\\.\\gridLineWidth, #yAxis\\.\\gridLineWidth',
      '#yAxis\\[0\\]\\.\\gridZIndex, #yAxis\\.\\gridZIndex'
    ]
  },
  '.everviz-dummy-rect.xaxis-tick': {
    name: 'xAxis-ticks',
    highlightAll: true,
    steps: [
      {
        element: '.node#xAxis\\[0\\] > div,.node#xAxis > div'
      },
      {
        parent: '.right-advance-panel',
        element: '#xAxis\\[0\\]\\.\\tickAmount, #xAxis\\.\\tickAmount'
      }
    ],
    highlights: [
      '#xAxis\\[0\\]\\.\\tickAmount, #xAxis\\.\\tickAmount',
      '#xAxis\\[0\\]\\.\\tickColor, #xAxis\\.\\tickColor',
      '#xAxis\\[0\\]\\.\\tickInterval, #xAxis\\.\\tickInterval',
      '#xAxis\\[0\\]\\.\\tickLength, #xAxis\\.\\tickLength',
      '#xAxis\\[0\\]\\.\\tickmarkPlacement, #xAxis\\.\\tickmarkPlacement',
      '#xAxis\\[0\\]\\.\\tickPixelInterval, #xAxis\\.\\tickPixelInterval',
      '#xAxis\\[0\\]\\.\\tickPosition, #xAxis\\.\\tickPosition',
      '#xAxis\\[0\\]\\.\\tickPositions, #xAxis\\.\\tickPositions',
      '#xAxis\\[0\\]\\.\\tickWidth, #xAxis\\.\\tickWidth'
    ]
  },
  '.everviz-dummy-rect.yaxis-tick': {
    name: 'yAxis-ticks',
    highlightAll: true,
    steps: [
      {
        element: '.node#yAxis\\[0\\] > div,.node#yAxis > div'
      },
      {
        parent: '.right-advance-panel',
        element: '#yAxis\\[0\\]\\.\\tickAmount, #yAxis\\.\\tickAmount'
      }
    ],
    highlights: [
      '#yAxis\\[0\\]\\.\\tickAmount, #yAxis\\.\\tickAmount',
      '#yAxis\\[0\\]\\.\\tickColor, #yAxis\\.\\tickColor',
      '#yAxis\\[0\\]\\.\\tickInterval, #yAxis\\.\\tickInterval',
      '#yAxis\\[0\\]\\.\\tickLength, #yAxis\\.\\tickLength',
      '#yAxis\\[0\\]\\.\\tickmarkPlacement, #yAxis\\.\\tickmarkPlacement',
      '#yAxis\\[0\\]\\.\\tickPixelInterval, #yAxis\\.\\tickPixelInterval',
      '#yAxis\\[0\\]\\.\\tickPosition, #yAxis\\.\\tickPosition',
      '#yAxis\\[0\\]\\.\\tickPositions, #yAxis\\.\\tickPositions',
      '#yAxis\\[0\\]\\.\\tickWidth, #yAxis\\.\\tickWidth'
    ]
  },
  '.everviz-dummy-rect.xaxis-line': {
    name: 'xAxis-line',
    highlightAll: true,
    steps: [
      {
        element: '.node#xAxis\\[0\\] > div,.node#xAxis > div'
      },
      {
        parent: '.right-advance-panel',
        element: '#xAxis\\[0\\]\\.\\lineColor, #xAxis\\.\\lineColor'
      }
    ],
    highlights: [
      '#xAxis\\[0\\]\\.\\lineColor, #xAxis\\.\\lineColor',
      '#xAxis\\[0\\]\\.\\lineWidth, #xAxis\\.\\lineWidth'
    ]
  },
  '.everviz-dummy-rect.yaxis-line': {
    name: 'yAxis-line',
    highlightAll: true,
    steps: [
      {
        element: '.node#yAxis\\[0\\] > div,.node#yAxis > div'
      },
      {
        parent: '.right-advance-panel',
        element: '#yAxis\\[0\\]\\.\\lineColor, #yAxis\\.\\lineColor'
      }
    ],
    highlights: [
      '#yAxis\\[0\\]\\.\\lineColor, #yAxis\\.\\lineColor',
      '#yAxis\\[0\\]\\.\\lineWidth, #yAxis\\.\\lineWidth'
    ]
  },

  //Stock
  '.highcharts-range-selector-buttons': {
    name: 'range-selector-buttons',
    steps: [
      {
        element: '.node#rangeSelector',
        scrollToTop: true
      }
    ],
    convertToRect: true,
    useCalculatedValue: true
  },
  '.highcharts-range-selector-group .highcharts-input-group': {
    name: 'range-selector-buttons',
    steps: [
      {
        element: '.node#rangeSelector'
      },
      {
        parent: '.right-advance-panel',
        element: '#rangeSelector\\.inputEnabled'
      }
    ],
    highlights: ['#rangeSelector\\.inputEnabled'],
    convertToRect: true,
    useCalculatedValue: true
  },
  '.highcharts-navigator': {
    name: 'range-selector-buttons',
    steps: [
      {
        element: '.node#navigator',
        scrollToTop: true
      }
    ],
    convertToRect: true,
    useCalculatedValue: true
  },

  //Map
  '.highcharts-button.highcharts-map-navigation': {
    name: 'map-navigation',
    steps: [
      {
        element: '.node#mapNavigation',
        scrollToTop: true
      }
    ],
    convertToRect: true,
    useCalculatedValue: true,
    highlightAll: true
  }
};
